import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Dashboard from './views/authorized/groupdashboard'
import groups from './views/authorized/groupdashboard/groups.vue'
import events from './views/authorized/groupdashboard/events.vue'

import global_users from './views/authorized/groupdashboard/users.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      props: true,
      component: Dashboard,
      redirect: {name:"groups"},
      children:[
        {
          'path':'',
          name: "groups",
          component: groups
        },
        {
          'path':"globalusers",
          name:"global_users",
          component: global_users
        }
      ]
    },
    {
      path: '/dashboard/:id',
      name: 'dashboard',
      props: true,
      component: Dashboard,
      children:[
        {
          path:'groups',
          name:"groups",
          component: groups
        },
        {
          path:'events',
          props:true,
          name:"events",
          component: events
        },
        {
          path:'users',
          name:"users",
          props:true,
          component: global_users
        }
      ]
    },
    {
      "path":"*",
      name: "notfound",
      redirect: "dashboard"
    }
  ]
})
